import EventNames from '../constants/EventNames';
import { FACEBOOK_APP_ID } from '../constants/config';
import SOURCE from '../constants/Source';
import EventPropertyValues from '../constants/EventPropertyValues';

class AbstractFacebook {
  constructor() {
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
    this.allowedEvents = [
      EventNames.VIEW_SCREEN,
      EventNames.ADD_PAYMENT_INFO,
      EventNames.COMPLETE_REGISTRATION,
      EventNames.DOWNGRADE_PLAN,
      EventNames.UPGRADE_PLAN,
      EventNames.START_TRIAL,
    ];
  }

  transformEventName = (name) => {
    switch (name) {
      case EventNames.ADD_PAYMENT_INFO:
        return EventNames.FACEBOOK.ADD_PAYMENT_INFO;
      case EventNames.COMPLETE_REGISTRATION:
        return SOURCE === EventPropertyValues.MOBILE
          ? EventNames.FACEBOOK.COMPLETE_REGISTRATION_MOBILE
          : EventNames.FACEBOOK.COMPLETE_REGISTRATION_WEB;
      default:
        return name;
    }
  };

  shouldLogEvent = (name) => {
    return this.allowedEvents.includes(name);
  };
}

export default AbstractFacebook;
